<template>
  <div>
    <el-card>
      <div slot="header">创建商户</div>
      <el-form :model="form" inline>
        <el-form-item label="名称"><el-input v-model="form.name" /></el-form-item>
        <el-form-item label="席位"><el-input-number v-model="form.seat_limit" :min="1" /></el-form-item>
        <el-form-item label="管理员"><el-input v-model="form.owner_username" /></el-form-item>
        <el-form-item label="密码"><el-input v-model="form.owner_password" type="password" /></el-form-item>
        <el-form-item><el-button type="primary" @click="submit">创建</el-button></el-form-item>
      </el-form>
    </el-card>

    <el-card style="margin-top:16px;">
      <div slot="header">商户列表</div>
      <el-table :data="list">
        <el-table-column prop="id" label="ID" width="80" />
        <el-table-column prop="name" label="名称" />
        <el-table-column prop="seat_limit" label="席位" width="100" />
        <el-table-column prop="app_key" label="AppKey" />
        <el-table-column label="调整席位" width="210">
          <template slot-scope="{ row }">
            <el-input-number v-model="seatMap[row.id]" :min="1" size="mini" />
            <el-button size="mini" type="primary" @click="saveSeat(row.id)">保存</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import { createMerchant, merchantList, updateSeat } from '../api/admin';

export default {
  data() {
    return {
      list: [],
      seatMap: {},
      form: { name: '', seat_limit: 3, owner_username: '', owner_password: '' }
    };
  },
  methods: {
    async load() {
      const { data } = await merchantList();
      this.list = data.data || [];
      this.list.forEach(v => this.$set(this.seatMap, v.id, v.seat_limit));
    },
    async submit() {
      await createMerchant(this.form);
      this.form = { name: '', seat_limit: 3, owner_username: '', owner_password: '' };
      await this.load();
    },
    async saveSeat(id) {
      await updateSeat(id, this.seatMap[id]);
      await this.load();
    }
  },
  created() {
    this.load();
  }
};
</script>

